import { render, staticRenderFns } from "./IotDeveloper.vue?vue&type=template&id=263f9715&scoped=true&"
import script from "./IotDeveloper.vue?vue&type=script&lang=js&"
export * from "./IotDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./IotDeveloper.vue?vue&type=style&index=0&id=263f9715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f9715",
  null
  
)

export default component.exports